export enum DRAWING_GEOMETRY {
  MARKER = 'Marker',
  LINE = 'Line',
  POLYGON = 'Polygon',
  MULTIPOLYGON = 'MultiPolygon',
  CIRCLE = 'Circle',
}
